var MainNavigation = function() {
	this.navigation = $("nav");
	this.channelBarItems = $(".sw-channel-item");

	this.channelMenus = new Object();
};

MainNavigation.prototype = {
	Setup : function() {
		if (this.navigation.length > 0) {		
			this.channelBarItems.off("hover");

			var classRef = this;

			if ($("#sw-channel-list-container").css("position") === "fixed") {
				$("#toggle-mobile").change(this._toggleMobileMainMenu);

				var $channelLinks = this.channelBarItems.has(".sw-channel-dropdown").find("> a");
				
				$channelLinks.off( "focus touchstart" );

				$channelLinks.click(this._toggleMobileChannelMenu);
			}
			else {
				this.channelBarItems.hover(
					function( event ) {
						classRef._hover(event, classRef, this );
					},
					function( event ) {
						classRef._blur(event, classRef, this );
					}
				);
			}
		}
	},

	IsMobile: function () {
		return ($("#mobile-menu").css("display") === "block");
	},

	_hover : function( event, classRef, channelBarItemRef ) {
		event.stopImmediatePropagation();

		if (classRef.channelMenus[channelBarItemRef.id] === undefined) {
			var subList = $(channelBarItemRef).children('ul');

			if ($.trim(subList.html()) !== "") {
				subList.slideDown(500);
				subList.attr("aria-hidden", "false").attr( "aria-expanded", "true" ).attr( "aria-hidden", "false" ).attr( "aria-hidden", "false" );
			}

			$(channelBarItemRef).addClass("hover");
		}
		else {
			window.clearTimeout(classRef.channelMenus[channelBarItemRef.id]);
			classRef.channelMenus[channelBarItemRef.id] = undefined;
		}
	},

	_blur: function (event, classRef, channelBarItemRef) {
		event.stopImmediatePropagation();

		classRef.channelMenus[channelBarItemRef.id] = window.setTimeout(function () {
			classRef._closeMenu(classRef, channelBarItemRef);
		}, 525);
	},

	_closeMenu: function (classRef, channelBarItemRef) {
		//$(".sw-channel-dropdown").hide();
		$(channelBarItemRef).find(".sw-channel-dropdown").slideUp(250);
		$(channelBarItemRef).removeClass("hover");

		classRef.channelMenus[channelBarItemRef.id] = undefined;

		var subList = $(channelBarItemRef).children('ul');

		if ($.trim(subList.html()) !== "") {
			subList.attr("aria-hidden", "true").attr( "aria-expanded", "false" ).attr( "aria-hidden", "true" );
		}
	},

	_toggleMobileMainMenu : function(event) {
		$("main, #header-nav").toggleClass("mobile-menu-open");
	},

	_toggleMobileChannelMenu : function(event) {
		event.preventDefault();
		event.stopImmediatePropagation();

		$(this).toggleClass("active").siblings(".sw-channel-dropdown").slideToggle(500);
	}
};